// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Clear: React.FC = () => {
    return (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 30 30"
            enableBackground="new 0 0 30 30"
            xmlSpace="preserve"
        >
            <polygon
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
                points="29.58,3.35 26.65,0.42 15,12.06 3.35,0.42 0.42,3.35 12.06,15 0.42,26.65
	3.35,29.58 15,17.94 26.65,29.58 29.58,26.65 17.94,15 "
            />
        </svg>
    );
};

export default React.memo(Clear);
